import { render } from "./MONPage.vue?vue&type=template&id=058dab11&scoped=true"
import script from "./MONPage.vue?vue&type=script&lang=js"
export * from "./MONPage.vue?vue&type=script&lang=js"

import "./MONPage.vue?vue&type=style&index=0&id=058dab11&lang=scss&scoped=true"

import exportComponent from "/home/scotty/git/beamy/monolith/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-058dab11"]])

export default __exports__